import { Icon } from "@/components/ui";

// Lightweight toast — single transient message, fixed bottom-center.
// Uses <output> (an ARIA live region by default) so Biome's useSemanticElements
// is satisfied without a role="status" on a <div>.
export const Toast = ({ message }: { message: string | null }) => {
  if (!message) return null;
  return (
    <output
      style={{
        position: "fixed",
        left: "50%",
        bottom: 90,
        transform: "translateX(-50%)",
        zIndex: 80,
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        background: "var(--bg-card)",
        color: "var(--text-base)",
        fontSize: 13.5,
        fontWeight: 700,
        padding: "13px 22px",
        borderRadius: 16,
        boxShadow: "rgba(0,0,0,0.28) 0px 10px 28px",
      }}
    >
      <Icon name="check" size={16} color="var(--brand)" stroke={2.6} />
      {message}
    </output>
  );
};
